const words = ["Operations", "Certificates", "Maintenance", "Compliance", "Inspection-ready"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-display text-5xl italic text-[#0B192C] md:text-7xl">{w}</span>
        <span className="h-3 w-3 rotate-45 bg-[#C87D55]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#1E3E62]/15 bg-[#F4EDE3] py-8" aria-hidden="true">
    <div className="marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
